module.exports = __webpack_public_path__ + "static/media/packPeda.5dd3ffb0.png";